import React, { useContext } from 'react';
import Switch from "react-switch";
//import { useState } from 'react';
import { permission_type } from '../../constants';
import account from '../../context/generalaccount';
export default function Control(){
  const {control,changeControl,loading}=useContext(account);
 //  const [ischeck,setCheck]=useState(false);
   // const {finaldetails,loading,dploading,control,handleChangeDetails,submitDetails,changeControl,changeDp}=useProfile();
   const  pstyle='font-Roboto text-gray-600 font-medium tracking-wider text-sm';
    return (
        <div className='flex space-x-1 mt-4'>

                <div className='flex flex-col space-y-3'>
                
                 
                    {Object.entries(permission_type).map(([key, value]) => (
                        <p className={pstyle} key={key}>{value}</p>
                      ))}
                
                </div>
          <div className='flex flex-col space-y-1'>
          
          
           {Object.entries(permission_type).map(([key, value]) => (
            <Switch key={key} onChange={(e)=>changeControl(value,e)} checked={control[value]} disabled={loading || (control.user===localStorage["_id"])} />
          ))}
          
          </div>
        </div>
    )
}